import React, { useEffect, useState } from "react";
import "../../styles/OurTeam.scss";

interface TeamItem {
  image: string;
  name?: string;
  description: string;
}

export default function OurTeam() {
  const [teamData, setTeamData] = useState<TeamItem[]>([]);

  useEffect(() => {
    fetch("/resources/team.json")
      .then((res) => res.json())
      .then(setTeamData)
      .catch(console.error);
  }, []);

  return (
    <div className="team-wrapper">
      <header className="team-header">
        <div className="team-header-bg" />
        <div className="team-header-content">
          <h1 className="ot-title ot-cutout-text" data-text="Our Team">
            Our Team
          </h1>
          <h1 className="ot-title ot-cutout-text" data-text="APLIC 2027">
            APLIC 2027
          </h1>
        </div>
      </header>

      <section className="team-section">
        <div className="team-container">
          {teamData.map((item, index) => (
            <div className="team-item" key={index}>
              <img
                src={item.image}
                className="team-image"
                alt={item.name || "Team Image"}
              />

              <div className="team-text">
                {item.name && <h2 className="team-name">{item.name}</h2>}
                <p className="team-description">{item.description}</p>
              </div>
            </div>
          ))}

          <p className="team-footer">
            Together, LUAP and APFINSA will bring together APLIC 2027, uniting
            thousands of financial professionals to celebrate innovation,
            leadership, and success in motion.
          </p>
        </div>
      </section>
    </div>
  );
}
